import { CSSProperties, FC, useMemo } from 'react';
import RiveComponent from '@rive-app/react-canvas';
import AniDance from 'public/assets/rive/ani-dance.riv';
import AxeDance from 'public/assets/rive/axe-dance.riv';
import AxePanic from 'public/assets/rive/axe-panic.riv';
import FleDance from 'public/assets/rive/fle-dance.riv';
import GusDance from 'public/assets/rive/gus-dance.riv';
import GusDisgust from 'public/assets/rive/gus-disgust.riv';
import GusScratch from 'public/assets/rive/gus-scratch.riv';
import HalDance from 'public/assets/rive/hal-dance.riv';
import HalSnap from 'public/assets/rive/hal-snap.riv';
import HalWiggle from 'public/assets/rive/hal-wiggle.riv';
import HypDance from 'public/assets/rive/hyp-dance.riv';
import HypDazed from 'public/assets/rive/hyp-dazed.riv';
import HypExcited from 'public/assets/rive/hyp-excited.riv';
import NomDance from 'public/assets/rive/nom-dance.riv';
import SidDance from 'public/assets/rive/sid-dance.riv';
import TidDance from 'public/assets/rive/tid-dance.riv';
import TidSnooze from 'public/assets/rive/tid-snooze.riv';

const BendieLookup = {
  AniDance,
  AxeDance,
  AxePanic,
  FleDance,
  GusDance,
  GusDisgust,
  GusScratch,
  HalDance,
  HalSnap,
  HalWiggle,
  HypDance,
  HypDazed,
  HypExcited,
  NomDance,
  SidDance,
  TidDance,
  TidSnooze,
};

export enum Bendie {
  Ani = 'Ani',
  Axe = 'Axe',
  Fle = 'Fle',
  Gus = 'Gus',
  Hal = 'Hal',
  Hyp = 'Hyp',
  Nom = 'Nom',
  Sid = 'Sid',
  Tid = 'Tid',
}

export enum Motion {
  Dance = 'Dance',
  Dazed = 'Dazed',
  Disgust = 'Disgust',
  Excited = 'Excited',
  Panic = 'Panic',
  Scratch = 'Scratch',
  Snap = 'Snap',
  Wiggle = 'Wiggle',
  Snooze = 'Snooze',
}

interface Props {
  bendie: Bendie;
  motion: Motion;
  style?: CSSProperties;
}

export const BendieAnimation: FC<Props> = ({ bendie, motion, style }) => {
  const key = `${bendie}${motion}` as keyof typeof BendieLookup;

  if (typeof BendieLookup[key] === 'undefined') {
    throw new Error(`${key} is not a bendie motion`);
  }

  return <RiveComponent style={style} src={BendieLookup[key]} />;
};

export const DancingBendie = () => {
  const bendie = useMemo(() => {
    const bendies = Object.values(Bendie);
    const max = bendies.length - 1;
    const min = 0;
    const idx = Math.floor(Math.random() * (max - min + 1)) + min;

    return BendieLookup[`${bendies[idx]}Dance`];
  }, []);

  return <RiveComponent src={bendie} />;
};
